import { schemes } from "@zeal/common";
import { z } from "zod";

export const createFinixCardRequestSchema = z.object({
  token: z.string(),
  customerAccountID: schemes.uuid(),
  companyID: schemes.uuid(),
});

export const createFinixCardResponseSchema = z.object({
  id: z.string(),
});

export type TCreateFinixCardRequest = z.infer<
  typeof createFinixCardRequestSchema
>;
export type TCreateFinixCardResponse = z.infer<
  typeof createFinixCardResponseSchema
>;
